module.exports = __webpack_public_path__ + "static/media/wedding-catering-6.60290acf.jpg";